import { Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const SitePerformanceSummaryData = ({
  sitePerformanceLoader,
  sitePerformance = [],
}) => {
  return (
    <>
      <h6 className="fw-bold mb-2">Site Performance Summary</h6>
      {sitePerformanceLoader ? (
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
      ) : (
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th className="text-center" style={{ width: 45 }}>
                Sr.
              </th>
              <th>Site</th>
              <th>Total SDV</th>
              <th>Avg. Time to SDV</th>
              <th>% SDV {`<`} 7 Days</th>
              <th>Overdue SDV</th>
            </tr>
          </thead>
          <tbody>
            {sitePerformance?.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>{item?.siteName}</td>
                <td>{item?.totalSDV}</td>
                <td>{item?.avarangeTimeSDV}</td>
                <td>{item?.SDV7Days}</td>
                <td>{item?.overdueSDV}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default SitePerformanceSummaryData;
